import DiffMatchPatch from "diff-match-patch";
import styled from "@emotion/styled";

interface TextDiffProps {
  oldText: string | undefined;
  newText: string;
}

export const TextDiff = ({ oldText, newText }: TextDiffProps) => {
  const dmp = new DiffMatchPatch();
  const diffs = dmp.diff_main(oldText || "", newText || "");
  dmp.diff_cleanupSemantic(diffs);

  return (
    <span>
      {diffs.map(([op, data]: [number, string], idx: number) => {
        if (op === DiffMatchPatch.DIFF_INSERT) {
          return <StyledInsertSpan key={idx}>{data}</StyledInsertSpan>;
        } else if (op === DiffMatchPatch.DIFF_DELETE) {
          return <StyledDeleteSpan key={idx}>{data}</StyledDeleteSpan>;
        } else {
          return <StyledEqualSpan key={idx}>{data}</StyledEqualSpan>;
        }
      })}
    </span>
  );
};

const StyledInsertSpan = styled.span`
  color: ${({ theme }) => theme.colors.green.x500};
`;

const StyledDeleteSpan = styled.span`
  color: ${({ theme }) => theme.colors.red.x500};
  text-decoration: line-through;
`;

const StyledEqualSpan = styled.span`
  color: ${({ theme }) => theme.colors.mblue.x500};
`;
